import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerOnboardingEmail,
  BackendMutationSaveCustomerOnboardingEmailArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOMER_ONBOARDING_EMAIL } from './schema';

const MUTATION = gql`
  mutation SaveCustomerOnboardingEmail(
    $customerId: ID!
    $emailContent: String!
    $subject: String!
    $enabled: Boolean
  ) {
    saveCustomerOnboardingEmail(
      customerId: $customerId
      emailContent: $emailContent
      subject: $subject
      enabled: $enabled
    ) {
      ...CustomerOnboardingEmail
    }
  }
  ${FRAGMENT_CUSTOMER_ONBOARDING_EMAIL}
`;

type Variables = BackendMutationSaveCustomerOnboardingEmailArgs;
type Result = BackendCustomerOnboardingEmail;

export const saveCustomerOnboardingEmail = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
